import { LatLngExpression } from 'leaflet';


import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
//import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { from, Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Booking } from '../interfaces/booking';
import { getWsObs } from '../realtime/operators';
import { AuthService } from './auth.service';
import { ConnectionStatus, NetworkService } from './network.service';
import { OfflineManagerService } from './offline-manager.service';
import { ToastService } from './toast.service';
import * as momentTimeZone from 'moment-timezone';
import { Location } from '../interfaces/location';
import { BookingRelation as BookingRelation } from '../enums/booking-relation';

@Injectable({
  providedIn: 'root'
})

export class BookingService {

  constructor(
    private http: HttpClient,
    private storage: Storage,
    public network: NetworkService,
    public authService: AuthService,
    public toastService: ToastService,
    //public translate: TranslateService,
    public offlineManager: OfflineManagerService
  ) { }

  /**
   * Get the all bookings from a company.  Be aware that this requested can contain a lot of data!
   *
   * @param companyId ID of the company for the requested events
   * @param relation Get bookings only with the IDs (default) or also the related table informations
   *
   * @returns All bookings of the company
   */
  getAllBookings(companyId: string, relation = BookingRelation.NONE): Observable<Booking[]> {
    return this.http.get<Booking[]>(
      `${environment.url}/bucket/${environment.buckets.bookings}/data?relation=${relation}&filter={"company._id":"${companyId}"}`
    );
  }

  /**
   * Get the bookings from a company for a specific time range.
   *
   * @param companyId ID of the company for the requested events
   * @param fromDate start date of the time range
   * @param toDate end date of the time range
   * @param relation Get bookings only with the IDs (default) or also the related table informations
   *
   * @returns All bookings of the company in that time range
   */
  getBookingsWithRange(companyId: string, fromDate: Date, toDate: Date, relation = BookingRelation.NONE): Observable<Booking[]> {
    return this.http.get<Booking[]>(
      // eslint-disable-next-line max-len
      `${environment.url}/bucket/${environment.buckets.bookings}/data?relation=${relation}&filter={"company._id":"${companyId}","start_date":{"$gte":"Date(${fromDate.toISOString()})"},"end_date":{"$lt":"Date(${toDate.toISOString()})"}}`
    );
  }

  // TODO: company aus Token
  addBooking(companyId: string, data: any): Observable<any> {
    let url = '';
    if (data.employee == null || data.services == null) {
      return this.http.post<Booking>(
        `${environment.url}/bucket/${environment.buckets.bookings}/data`,
        data
      );
    } else {
      // EVENT
      url = `${environment.url}/fn-execute/appointment`;
      // if (companyType !== 'Restaurant' && companyType !== 'Consulting') {
      //   url = `${environment.url}/fn-execute/appointment`;
      // } else {
      //   url = `${environment.url}/bucket/${environment.buckets.bookings}/data`;
      // }

      data.company = companyId;

      const status = this.network.getCurrentNetworkStatus();

      //online
      if (status === ConnectionStatus.Online) {
        return this.http.post(url, data, { observe: 'response' }).pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              /*this.toastService.showToast(
                'danger',
                this.translate.instant('schedule.something_wrong')
              );*/
            }
            return of(null);
          }),
          tap(response => {
            if (response) {
              //this.toastService.showToast('success', this.translate.instant('schedule.added'));
            }
          })
        );
      } else {
        return from(this.offlineManager.storeRequest(url, 'POST', data));
      }
    }
  }

  editBooking(companyId: string, companyType: string, data: Booking): Observable<any> {
    data.company = companyId;
    if (data.employee == null) {
      data.employee = undefined;
      // console.log(data);
      return this.http.put<Booking>(
        // eslint-disable-next-line no-underscore-dangle
        `${environment.url}/bucket/${environment.buckets.bookings}/data/${data._id}`,
        data
      );
    } else {
      // if (companyType != 'Restaurant') {
      //   url = `${environment.url}/fn-execute/appointment?id=${data._id}`;
      // } else {
      //   url = `${environment.url}/bucket/${environment.buckets.appointments}/data/${data._id}`;
      // }
      // eslint-disable-next-line no-underscore-dangle
      const url = `${environment.url}/bucket/${environment.buckets.bookings}/data/${data._id}`;
      return this.network.status.pipe(
        switchMap(status => {
          if (status === ConnectionStatus.Offline) {
            return from(this.offlineManager.storeRequest(url, 'PUT', data));
          } else {
            // console.log(data);
            return this.http
              .put(url, data, {
                observe: 'response'
              })
              .pipe(
                catchError((err: HttpErrorResponse) => {
                  if (err.error instanceof Error) {
                    /*this.toastService.showToast(
                      'danger',
                      this.translate.instant('schedule.something_wrong')
                    );*/
                  } else {
                    /*this.toastService.showToast(
                      'danger',
                      this.translate.instant(err.error.message)
                    );*/
                  }
                  return of(null);
                }),
                tap(response => {
                  if (response) {
                    /*this.toastService.showToast(
                      'success',
                      this.translate.instant('schedule.edited')
                    );*/
                  }
                })
              );
          }
        })
      );
    }
  }

  deleteBooking(bookingId: string): Observable<any> {
    const url = `${environment.url}/bucket/${environment.buckets.bookings}/data/${bookingId}`;
    return this.network.status.pipe(
      switchMap(status => {
        if (status === ConnectionStatus.Offline) {
          return from(this.offlineManager.storeRequest(url, 'DELETE', ''));
        } else {
          return this.http.delete(url, {
            observe: 'response'
          });
        }
      })
    );
  }

  /*Converts Date to given timezone*/

  convertTime(date: Date, timezone): Date {
    const tzMoment = momentTimeZone.tz(date.toString(), timezone);
    const offsetToUTCgivenDate = tzMoment.utcOffset() / 60;
    //console.log('Offset to utc: ', offsetToUTCgivenDate);
    const newDate = new Date(date);
    newDate.setHours(newDate.getHours() - offsetToUTCgivenDate);
    return newDate;
  }

  calcBookedInPercentWeek(
    appointments: Booking[],
    employees: Location[]
  ): { day: Date; bookedInPercent: number }[] {
    const today = new Date();
    const today1 = new Date(today);
    today1.setDate(today.getDate() + 1);
    const today2 = new Date(today);
    today2.setDate(today.getDate() + 2);
    const today3 = new Date(today);
    today3.setDate(today.getDate() + 3);
    const today4 = new Date(today);
    today4.setDate(today.getDate() + 4);
    const today5 = new Date(today);
    today5.setDate(today.getDate() + 5);
    const today6 = new Date(today);
    today6.setDate(today.getDate() + 6);

    const week: Date[] = [today, today1, today2, today3, today4, today5, today6];
    const schedulesPerDay: Booking[][] = [];
    const workingHourTotalPerDay: number[] = [];
    const result: { day: Date; bookedInPercent: number }[] = [];

    for (let i = 0; i < week.length; i++) {
      schedulesPerDay[i] = [];
      workingHourTotalPerDay[i] = 0;
      result[i] = {
        day: week[i],
        bookedInPercent: 0
      };
    }

    appointments.forEach(app => {
      const date = new Date(app.start_date);
      for (let i = 0; i < week.length; i++) {
        if (
          date.getFullYear() === week[i].getFullYear() &&
          date.getMonth() === week[i].getMonth() &&
          date.getDate() === week[i].getDate()
        ) {
          //Fill array if same day
          schedulesPerDay[i].push(app);
        }
      }
    });

    //calc total working capacity
    for (const employee of employees) {
      for (const workingHour of employee.working_hours) {
        const arrayEnd = workingHour.end_time.split(':');
        const end = (parseInt(arrayEnd[0], 10) * 60 * 60 + parseInt(arrayEnd[1], 10) * 60) / 60 / 60;
        const arrayStart = workingHour.start_time.split(':');
        const start =
          (parseInt(arrayStart[0], 10) * 60 * 60 + parseInt(arrayStart[1], 10) * 60) / 60 / 60;

        const diff = end - start - 1;
        workingHourTotalPerDay[workingHour.day_of_week - 1] += diff;
      }
    }

    //console.log('WORKINGHOURSTOTAL: ', workingHourTotalPerDay);
    //calc booked
    const workingHourbookedPerDay = [...workingHourTotalPerDay];
    for (const schedules of schedulesPerDay) {
      for (const enrty of schedules) {
        const end = new Date(enrty.end_date);
        const start = new Date(enrty.start_date);
        const length = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
        const day = start.getDay();
        workingHourbookedPerDay[day - 1] -= length;
      }
    }

    //calc percent
    for (let i = 0; i < workingHourTotalPerDay.length; i++) {
      result[i].bookedInPercent =
        100 - (workingHourbookedPerDay[i] * 100) / workingHourTotalPerDay[i];
    }
    return result;
  }

  //TODO
  async calcBookedInSeatsWeek(appointments: Booking[], employees: Location[]) {
    const today = new Date();
    const today1 = new Date(today);
    today1.setDate(today.getDate() + 1);
    const today2 = new Date(today);
    today2.setDate(today.getDate() + 2);
    const today3 = new Date(today);
    today3.setDate(today.getDate() + 3);
    const today4 = new Date(today);
    today4.setDate(today.getDate() + 4);
    const today5 = new Date(today);
    today5.setDate(today.getDate() + 5);
    const today6 = new Date(today);
    today6.setDate(today.getDate() + 6);

    const week: Date[] = [today, today1, today2, today3, today4, today5, today6];
    const schedulesPerday: { day: Date; servicegroup: string; schedules: Booking[] }[][] = [];
    const seatTotalPerDay: number[] = [];
    const seatBookedPerDay: { day: Date; servicegroup: string; amount: number }[][] = [];
    const result: { day: Date; bookedInPercent: number }[] = [];
    const serviceGroups = await this.storage.get('servicegroup');

    for (let i = 0; i < week.length; i++) {
      schedulesPerday[i] = [];
      seatBookedPerDay[i] = [];
      for (let j = 0; j < serviceGroups.length; j++) {
        schedulesPerday[i][j] = { day: week[i], servicegroup: serviceGroups[j].name, schedules: [] };
        seatBookedPerDay[i][j] = { day: week[i], servicegroup: serviceGroups[j].name, amount: 0 };
      }
      seatTotalPerDay[i] = 0;

      result[i] = {
        day: week[i],
        bookedInPercent: 0
      };
    }
    appointments.forEach(app => {
      const date = new Date(app.start_date);
      for (let i = 0; i < week.length; i++) {
        if (
          date.getFullYear() === week[i].getFullYear() &&
          date.getMonth() === week[i].getMonth() &&
          date.getDate() === week[i].getDate() &&
          app.serviceGroup !== undefined
        ) {
          for (const schedule of schedulesPerday[i]) {
            if (app.serviceGroup.name === schedule.servicegroup) {
              schedule.schedules.push(app);
            }
          }
          //Fill array if same day
        }
      }
    });

    //calc total working capacity
    for (const employee of employees) {
      if (employee.visible) {
        for (const workingHour of employee.working_hours) {
          const seats = employee.seats;
          seatTotalPerDay[workingHour.day_of_week - 1] += seats;
        }
      }
    }
    for (let i = 0; i < schedulesPerday.length; i++) {
      //day
      for (let j = 0; j < schedulesPerday[i].length; j++) {
        //cateogry (Abend, Mittag)
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let k = 0; k < schedulesPerday[i][j].schedules.length; k++) {
          if (schedulesPerday[i][j].schedules[k].employee !== undefined) {
            for (const employee of employees) {
              // eslint-disable-next-line no-underscore-dangle
              if (employee._id === schedulesPerday[i][j].schedules[k].employee) {
                seatBookedPerDay[i][j].amount += employee.seats;
                break;
              }
            }
          }
        }
      }
    }
    return [seatBookedPerDay, seatTotalPerDay];
  }

}
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function getEmptyAppointment() {
  return {
    _id: '',
    name: '',
    phone: '',
    start_date: new Date(),
    end_date: new Date(),
    employee: undefined,
    is_extendable: true,
    status: 0,
    seats: 2,
    tags: [],
    note: '',
    company: undefined

  };
}

